module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1052.49780d9e.png";